<style src="./Timebox.scss" lang="scss" scoped></style>
<template lang="html">
  <div
    class="component"
    :class="{'valid-fail': !isValid}">

    <label class="label">
      <span class="caption">{{ label }}</span>

      <div class="component-container">
        <div class="icon"></div>

        <input
          type="text"
          class="component-input"
          v-model="inputValue"
          v-mask="'##:##:00'"
          :placeholder="placeholder"
          @blur="runValidation"
          :autofocus="autofocus"
          v-debounce="debounce"
          @debounced="emitDebounce">

      </div>

      <span class="error-message" v-show="!isValid">{{ messageError[0] }}</span>
    </label>
  </div>
</template>

<script>
import {DebounceDirective} from '../helpers/debounce/Debounce'
import { mask } from 'vue-the-mask'
import ValidationMixin from '@/components/primitives/validator/validation-mixin/ValidationMixin.js'

export default {
  name: 'Timebox',
  mixins: [
    ValidationMixin
  ],
  directives: {
    debounce: DebounceDirective,
    mask
  },
  props: {
    label: {
      default: ''
    },
    value: {
      default: ''
    },
    placeholder: {
      default: ''
    },
    autofocus: {
      default: false
    },
    debounce: {
      default: null
    }
  },
  data () {
    return {
      inputValue: ''
    }
  },
  watch: {
    inputValue (pValue, pOldValue) {
      if (pValue !== pOldValue) this.$emit('input', pValue)
    },
    value: {
      handler (pValue) {
        this.inputValue = pValue
      },
      immediate: true
    }
  },
  methods: {
    blur () {
      this.$emit('blur')
    },
    emitDebounce () {
      this.$emit('debounce', this.inputValue)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/primitives/timebox/Timebox.vue